<template>
  <v-hover v-slot="{hover}" >
    <v-sheet
        style="position : relative"
        class="wsRoundedLight mb-2"
        :style="`border : 1px solid ${wsBACKGROUND}`">

      <v-sheet
          @click="expand=!expand"
          class="d-flex  justify-space-between py-3 transition-ease-in-out pointer"
          :color="hover || edit || editDropDownOn ? wsLIGHTCARD : ''"
      >
        <v-sheet    color="transparent" class="d-flex"  >

          <!-- Expand Icon-->
          <v-icon
              :class="expand ? 'rotate' : ''"
              class="pointer ml-3"
              :color="wsACCENT">
            mdi-menu-right
          </v-icon>
          <!-- Component Type Icon-->
          <v-icon
              :color="wsATTENTION"
              class="mr-2"
          >
             mdi-order-bool-ascending-variant
          </v-icon>
          <!-- Component name Icon-->
          <h4
              :contenteditable="edit ? 'plaintext-only' : 'false'"
              :placeholder="$t('EnterComponentName')"
              ref="text"
              style="outline: none; font-size: 16px; font-weight: 700 !important "
              :style="getTextStyle()"
              class="font-weight-medium text">
            {{ $t('Question') }} {{ index + 1 }}
            <span v-if="totalCorrectAnswers > 1" class="font-weight-regular" style="font-size: 13px">
              ({{$t('testing.multiple_choice.title')}}: {{ $t(`testing.multiple_choice.${question.multiple_type ? 'all' : 'single'}`) }})
            </span>
          </h4>

        </v-sheet>
        <div v-if="hover || edit || editDropDownOn " class="d-flex mr-4">
          <v-sheet width="35" color="transparent" class="pr-2">
            <ft-select
                @input="editAction"
                :items="actionsSelect"
                @expand="editDropDownOn = $event"
                left left-icons >
              <ws-icon-button  class="mr-4" v-if="hover || edit || editDropDownOn" />
            </ft-select>
          </v-sheet>

        </div>
      </v-sheet>

      <v-expand-transition>
        <div v-if="expand">
          <v-divider />

          <div  v-if="totalCorrectAnswers > 1">
            <div class="d-flex align-center justify-space-between" >

              <div class="py-3 px-8 ">
                <h4 class="mr-2">{{ $t('testing.multiple_choice.title')}} </h4>
                <h5 class="mr-2 font-weight-regular">{{ $t('testing.multiple_choice.description')}}</h5>
              </div>

              <ft-select
                  @input="editQuestion"
                  v-model="question.multiple_type"
                  :items="multipleQuestionTypeSelect"
              >
                <template #default="{text}">
                  <h5 class="font-weight-regular text-wrap">{{ text || $t('testing.multiple_choice.single') }}
                    <v-icon :color="wsACCENT">mdi-menu-down</v-icon>
                  </h5>
                </template>
              </ft-select>

            </div>
            <v-divider />
          </div>

          <div class="d-flex mt-4 px-8 justify-space-between">
            <h4 class="">{{ $t('Content') }}: </h4>
          </div>

          <ws-text-editor
              v-model="question.content"
              @input="editQuestion"
              :html="question.content_text"
              :placeholder="$t('EnterQuestionContent')"
              :question-id="question.uuid"
              no-file
          />

          <div class="pt-4"   :key="question.uuid">
            <answerEditor
                v-for="(answer , i ) in question.answers"
                @delete="deleteAnswer(i)"
                :answer="answer"
                :index="i"
                :question-id="question.uuid"
                :key="question.uuid + answer.uuid + i"
                :total-answers="totalAnswers"
                :total-correct-answers="totalCorrectAnswers"
            />

            <v-btn height="40" block @click="addAnswer" class="noCaps mt-10" :color="wsDARK" dark>
              <v-icon small>mdi-plus</v-icon>
              {{ $t('AddAnswer')}}
            </v-btn>
          </div>

        </div>
      </v-expand-transition>

      <ws-dialog
          v-model="displayDeleteDialog"
          :title="$t('DeleteQuestion')"
          close-delete
          display-confirm-delete
          @delete="deleteQuestion"
      />

    </v-sheet>
  </v-hover>
</template>

<script>
import answerEditor from "@/components/pages/westudy/admin/course/questionBanks/answerEditor";
import {mapActions, mapState} from "vuex";
export default {
  name: "questionEditor",
  components : {
    answerEditor
  },
  props : {
    question : {
      type : Object,
      default() { return {} }
    },
    index : {
      type : Number,
      default : 0
    }
  },
  data() {
    return {
      edit : false,
      editDropDownOn : false,
      expand : false,
      displayDeleteDialog : false
    }
  },
  computed : {
    ...mapState('courses', ['selectedLang']),
    multipleQuestionTypeSelect() {
      return [
        { text : this.$t('testing.multiple_choice.single') , value : null },
        { text : this.$t('testing.multiple_choice.all')  , value : 'all' },
        // { text : this.$t('testing.multiple_choice.percent')  , value : 'percent' },
      ]
    },
    totalAnswers() {
      return this.question.answers.length
    },
    totalCorrectAnswers() {
      if ( !this.question.answers ) {
        return []
      }
      return this.question.answers.filter(el=>el.correct).length
    },
    actionsSelect() {
      return [
        { text : this.$t('Duplicate') , value: 'duplicate' , icon : 'mdi-content-copy' },
        { text : this.$t('Delete') , value: 'delete' , icon : 'mdi-delete-outline' },
      ];
    },
  },
  methods : {
    ...mapActions('tests', [
        'ADD_EDIT_BANK_ANSWER',
        'ADD_EDIT_BANK_QUESTION'
    ]),

    editAction(type) {
      if ( type === 'delete' ) {
        this.displayDeleteDialog = true
      }
      if ( type === 'duplicate' ) {
        this.$emit('duplicate')
      }

    },
    async editQuestion() {

      let data = JSON.parse(JSON.stringify(this.question))
      data.lang = this.selectedLang

      let result = await this.ADD_EDIT_BANK_QUESTION(data)
      if ( !result ) {
        return
      }
    },
    deleteQuestion() {
      this.$emit('delete')
      this.displayDeleteDialog = false
    },

    async addAnswer() {

      let data = {
        question_bank_question_id : this.question.uuid,
        lang : this.selectedLang
      }

      let result = await this.ADD_EDIT_BANK_ANSWER(data)
      if (!result) {
        return
      }
      result.content = []

      this.question.answers.push(result)

    },
    deleteAnswer(index) {
      this.question.answers.splice(index,1)
    },

    getTextStyle() {
      let style = this.edit ? 'cursor : text;' : ' cursor : pointer;';
      return style
    },
    expandAction() {
      this.notify('Expand')
    }

  },
  mounted() {
    if (this.question.expand) {
      this.expand = true
    }
  }
}
</script>

<style scoped>
.rotate {
  transform: rotate(90deg);
}
</style>